import React from 'react';
import { Row, Col } from 'reactstrap';
import { faPencilAlt, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//Components
import MainCard from 'components/MainCard/MainCard';

export default function FichaPesquisaNaoColeta({ btnVoltar, naoColeta }) {

    return (
        <MainCard btnVoltar={btnVoltar}>
            <h5 className='bg-gradient bg-primary p-2 rounded-3 text-light'><FontAwesomeIcon icon={faPencilAlt} /> Detalhes da não coleta</h5>
            <Row style={{ color: "#666" }}>
                <Col md="6" lg="4">
                    <p><span className="fw-bold">Número da não coleta: </span>{naoColeta.id}</p>
                </Col>
                <Col md="6" lg="4">
                    <p><span className="fw-bold">Data: </span>{naoColeta.dataHora}</p>
                </Col>
                <Col md="6" lg="4">
                    <p><span className="fw-bold">Gerador: </span>{naoColeta.gerador}</p>
                </Col>
                <Col md="6" lg="4">
                    <p><span className="fw-bold">Localidade: </span>{naoColeta.localidade}</p>
                </Col>
                <Col md="6" lg="4">
                    <p><span className="fw-bold">Motivo: </span>{naoColeta.motivo}</p>
                </Col>
                <Col md="6" lg="4">
                    <p><span className="fw-bold">Coletor: </span>{naoColeta.coletor}</p>
                </Col>
            </Row>
            <h5 className='bg-gradient bg-primary p-2 rounded-3 text-light'><FontAwesomeIcon icon={faFileAlt} /> Anexos</h5>
            <Row>

                {naoColeta.imagens.map((value, index) => {
                    if (value) {
                        return (
                            <Col md="12" lg="4" className='d-flex justify-content-center'>
                                <img key={index} src={value} style={{ maxWidth: "100%", maxHeight: "300px" }} className='rounded-3' />
                            </Col>
                        );
                    }
                })}
            </Row>
        </MainCard>
    )
}